/* Handlebars Helpers =========================================================== */

Handlebars.registerHelper('switch', function(value, options) {
    this.switch_value = value;
    this.switch_break = false;
    return options.fn(this);
});

Handlebars.registerHelper('log', function(something) {
    console.log(something)
});

Handlebars.registerHelper('case', function(v1, operator, v2, options) {
    var args = Array.prototype.slice.call(arguments);
    var condition = (v1 == this.switch_value);
    options = args.pop();

    switch(operator) {
        case '||':
            condition = (v1 == this.switch_value || v2 == this.switch_value);
            break;
    }

    if (condition) {
        this.switch_break = true;
        return options.fn(this);
    }
});

Handlebars.registerHelper('default', function(value, options) {
    if (this.switch_break == false) {
        return options.fn(this);
    }
});

Handlebars.registerHelper('translate', function (string, variable, variable2) {
    return sprintf(Translator.trans(string), variable, variable2);
});

Handlebars.registerHelper("inc", function (value, options) {
    return parseInt(value) + 1;
});

Handlebars.registerHelper("incOffset", function (value, offset, options) {
    return parseInt(value) + 1 + parseInt(offset);
});

Handlebars.registerHelper('times', function (n, block) {
    var accum = '';
    for (var i = 0; i < n; ++i)
        accum += block.fn(i);
    return accum;
});

Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);

    return {
        "+": lvalue + rvalue,
        "-": lvalue - rvalue,
        "*": lvalue * rvalue,
        "/": lvalue / rvalue,
        "%": lvalue % rvalue
    }[operator];
});

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});

Handlebars.registerHelper('exists', function (variable, options) {
    if (typeof variable !== 'undefined') {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('formatCurrency', function (value) {
    if(!value) {
        return 0;
    }

    return formatValueByLocale(value);
});

Handlebars.registerHelper('length', function (value) {
    if(value && value.length) {
        return value.length
    }

    return 0;
});

Handlebars.registerHelper('notNegative', function (value) {
    return value > 0 ? value : 0;
});


Handlebars.registerHelper('eachSorted', function (array, key, opts) {

    var res = '';

    if(array){
        var sortedArray = array.slice(0).sort(function (a, b) {
            return a[key] - b[key];
        });

        sortedArray.forEach(function (obj) {
            res += opts.fn(obj)
        });
    }


    return res;
});

Handlebars.registerHelper('formatTimestamp', function (timestamp, format) {
    return moment.unix(timestamp).format(format);
});

Handlebars.registerHelper('formatLocaleTimestamp', function (timestamp, format) {
    var currentLocale = storage.getItem('locale');
    var unixMoment = moment.unix(timestamp);
    var localMoment = moment(unixMoment);

    if(currentLocale){
        localMoment.locale(currentLocale);
    }

    return localMoment.format(format);
});

Handlebars.registerHelper('formatToDateSystem', function (timestamp) {
    return formatToDateSystem(timestamp);
});

Handlebars.registerHelper('formatATOMToDateSystem', function(str) {

    const timestamp = new Date(str).getTime() / 1000;
    return formatToDateSystem(timestamp);

});

Handlebars.registerHelper('addClassIfWorldIsOpen', function (clazz) {
    return (world?.isOpen()) ? clazz : '';
});

Handlebars.registerHelper('addClassIfWorldIsFinished', function (clazz) {
    return (world?.isFinished()) ? clazz : '';
});

Handlebars.registerHelper('addClassIfWorldIsExpired', function (clazz) {
    return (world?.isExpired()) ? clazz : '';
});

Handlebars.registerHelper('addClassIfWorldIsFinishedOrExpired', function (clazz) {
    return (world?.isFinishedOrIsExpired()) ? clazz : '';
});

Handlebars.registerHelper('hexToRgba', function (hex, alpha) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    var a = alpha / 255;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
});

Handlebars.registerHelper('addClassIfWorldIsClosed', function (clazz) {
    return (world?.isClosed()) ? clazz : '';
});

Handlebars.registerHelper('ifUserIsSupervisor', function (options) {
    if (user.isSupervisor()) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('ifWorldIsFinishedOrExpired', function (options) {
    if (world?.isFinishedOrIsExpired()) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('ifConsecutive', function (n1, n2, options) {
    if (parseInt(n2) - parseInt(n1) == 1) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('generateSlideshowCss', function (images) {
    //This function was replaced by LoginBackgroundAnimation (sass problem)

    return '';
});

Handlebars.registerHelper('if_even', function (conditional, options) {
    if ((conditional % 2) == 0) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('if_odd', function (conditional, options) {
    if ((conditional % 2) != 0) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('if_mod', function (conditional, mod, options) {
    if ((conditional % mod) == 0) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

Handlebars.registerHelper('toLowerCase', function (str) {
    return str.toLowerCase();
});

Handlebars.registerHelper('toUpperCase', function (str) {
    return str.toUpperCase();
});

Handlebars.registerHelper('capitalize', function (str) {
    return str.toLowerCase().charAt(0).toUpperCase() + str.toLowerCase().slice(1);
});

Handlebars.registerHelper('printPositiveOrNegative', function (n) {
    return (n >= 0) ? `+${n}` : n;
});

Handlebars.registerHelper('round', function (n, decimals) {
    return parseFloat(n).toFixed(decimals);
});

Handlebars.registerHelper('roundOrInt', function (n, decimals) {
    n = parseFloat(n);
    if (n % 1 === 0) return Math.round(n);
    else return n.toFixed(decimals);
});

Handlebars.registerHelper('rankingColor', function (rankingId) {
    switch (rankingId) {
        case 1:
            return world?.theme.color_5;
        case 2:
            return world?.theme.color_4;
        case 3:
            return world?.theme.color_3;
        case 4:
            return world?.theme.color_2;
        case 5:
            return world?.theme.color_1;
    }
});

Handlebars.registerHelper('eachQuestionPoints', function (userQuestionPoints, opponentQuestionPoints, opts) {

    let questionPoints = [];

    let numQuestions = Math.min(userQuestionPoints.length, opponentQuestionPoints.length);

    for (let i = 0; i < numQuestions; i++) {
        if (userQuestionPoints[i] != null && opponentQuestionPoints[i] != null) {

            let userPoints = userQuestionPoints[i];
            let opponentPoints = opponentQuestionPoints[i];
            let questionIndex = i + 1;
            let questionResult = (userPoints > opponentPoints) ? 1 : ((userPoints == opponentPoints) ? 2 : 3);

            let questionClass = (questionIndex % 2 == 0) ? 'question-row-even' : 'question-row-odd';
            if (questionResult == 1) questionClass += ' question-row-win';
            if (questionResult == 2) questionClass += ' question-row-draw';
            if (questionResult == 3) questionClass += ' question-row-lose';

            questionPoints.push({
                question_index: questionIndex,
                question_result: questionResult,
                question_class: questionClass,
                user_points: userPoints,
                opponent_points: opponentPoints
            });
        }
    }

    let res = '';
    questionPoints.forEach(function (obj) {
        res += opts.fn(obj)
    });
    return res;
});

Handlebars.registerHelper('eachQuestionPointsPending', function (userQuestionPoints, opts) {

    var questionPoints = [];
    var numQuestions = userQuestionPoints.length;

    for (var i = 0; i < numQuestions; i++) {
        if (userQuestionPoints[i] != null) {

            var userPoints = userQuestionPoints[i];
            var questionIndex = i + 1;
            var questionResult = 2;
            var questionClass = (questionIndex % 2 == 0) ? 'question-row-even' : 'question-row-odd';

            questionClass += ' question-row-draw';
            questionPoints.push({
                question_index: questionIndex,
                question_result: questionResult,
                question_class: questionClass,
                user_points: userPoints
            });
        }
    }

    let res = '';
    questionPoints.forEach(function (obj) {
        res += opts.fn(obj)
    });
    return res;
});

Handlebars.registerHelper('secondsToHHMMSS', function (seconds) {
    return secondsToHHMMSS(seconds);
});

Handlebars.registerHelper('msToHHMMSS', function (ms) {
    return msToHHMMSS(ms);
});

Handlebars.registerHelper('hex2rgba', function (hex, alpha) {
    return hex2rgba(hex, alpha);
});

Handlebars.registerHelper('generateWsse', function () {
    return api.getHeader();
});

Handlebars.registerHelper('wrap-url', function(context) {
    var html = context;
    return new Handlebars.SafeString(wrapURLs(html));
});

Handlebars.registerHelper("bytesToMegabytes", function(bytes) {
    return Math.round((Number(bytes) + Number.EPSILON) * 100 / Math.pow(2, 20)) / 100;
});

Handlebars.registerHelper ('truncate', function (str, len, ellipsis) {
    if (str.length > len && str.length > 0) {
        var new_str = str + " ";
        new_str = str.substr (0, len);
        new_str = str.substr (0, new_str.lastIndexOf(" "));
        new_str = (new_str.length > 0) ? new_str : str.substr (0, len);

        return new Handlebars.SafeString (new_str + ellipsis);
    }
    return str;
});

Handlebars.registerHelper ('replace', function(str, searchValue, newValue) {
    return str.replace(searchValue, newValue);
});

Handlebars.registerHelper ('cleanHTML', function(str) {

    // Eliminar saltos de linea, multiples espacios, tags html rotos y tags html exceptuando los <em></em>
    return str.replace("\n", " ")
        .replace(/<(?!\/{0,1}\s*em)[^>]+>/g, "")
        .replace(/^[^<]*>/g, "")
        .replace(/<[^>]*$/g, "")
        .replace(/ +(?= )/g, "");

});

Handlebars.registerHelper('parseATOMDate', function(str) {
    return parseATOMDate(str);
});

Handlebars.registerHelper('sprintf', function (string, value1, value2) {
    return sprintf(string, value1, value2);
});

Handlebars.registerHelper("variable", function(variable) {
    return variable
});

Handlebars.registerHelper('or', function() {
    const args = Array.prototype.slice.call(arguments, 0, -1);
    return args.find(function(v) { return !!v; }) || '';
});

Handlebars.registerHelper('some', function (obj, a, b) {
    return obj.some(function(item) {
        return item[a] === b;
    });
});

Handlebars.registerHelper('isLast', function (obj, a, b) {
    const last = obj[obj.length - 1];

    return last[a] === b;
});

Handlebars.registerHelper("contains", function(value, array, options){
    // fallback...
    array = ( array instanceof Array ) ? array : [array];
    return (array.indexOf(value) > -1) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper("array", function() {
    return Array.prototype.slice.call(arguments,0,-1);
});

Handlebars.registerHelper('chooseSmartList', function(smartList, format, docType, isSpecial, isHighlight, data, options) {

    const smartListsDictViews = smartListsController.getSmartListsDictViews();

    if (isSpecial && format === "list" && (smartList === "LIST" || smartList === "WALL")) {
        if (docType === "GAME") {
            smartList = "SPECIAL_GAME";
        } else if (docType === "TEST") {
            smartList = "SPECIAL_TEST";
        } else {
            smartList = "SPECIAL_POLL";
        }
    }

    if (isHighlight) {
        smartList = "HIGHLIGHT";
    }

    return smartListsDictViews[smartList];

});

Handlebars.registerHelper('nextItem', function (array, index, options) {
    return options.fn(array[index + 1]);
});

Handlebars.registerHelper('isPathLMS', function () {
    return storage.getItem("lms_path_id") !== null;
});

// Para decidir cuando una cabecera de seccion estara desplegada / oculta en casos especiales
Handlebars.registerHelper('defaultCollapsedSectionHeader', function(hasAccordion, headerIndex) {
    return hasAccordion && (headerIndex !== 0);
});

Handlebars.registerHelper('parseString', function (value) {
    return String(value);
});

Handlebars.registerHelper('breaklines', function(text) {
    text = Handlebars.Utils.escapeExpression(text);
    text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
    return new Handlebars.SafeString(text);
});

Handlebars.registerHelper('isChatEnabled', function (options) {
    return $('.chatTab').length > 0 ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('i18n', function (string, variable, variable2) {
    return sprintf(Translator.trans(string), variable, variable2);
});

Handlebars.registerHelper('logger', function (options) {
    console.log('logger: ', options);
});

//filter an array of objects by key equals value
Handlebars.registerHelper('filter', function (arr, key, value) {
    return (arr || []).filter(function (item) {
        return item[key] === value;
    });
});

// Old version compatible with task
Handlebars.registerHelper('reactRender', function (options) {
    const hash = options.hash ? options.hash :  {};
    const {reactFn, targetId, data, options: op} = hash;

    window.setTimeout(function() {
        try {
            window.reactHandler(reactFn, targetId, data, op);
        } catch(e) {
            console.info(hash);
            console.error(e);
        }
    }, 400);
});

// New version compatible with path (diff data)
Handlebars.registerHelper('reactRenderV2', function (options) {
    const hash = options.hash ? options.hash :  {};
    const {reactFn, targetId, options: op, ...data} = hash;

    window.setTimeout(function() {
        try {
            window.reactHandler(reactFn, targetId, data, op);
        } catch(e) {
            console.info(hash);
            console.error(e);
        }
    }, 30);
});

Handlebars.registerHelper('reactButtonHaptic', function (options) {
    const hash = options.hash ? options.hash :  {};
    const {targetId, icon, colorScheme, margin} = hash;

    const data = {
        icon,
        style: {
            colorScheme,
            margin
        }
    };

    window.setTimeout(function() {
        try {
            window.reactHandler('buttonHaptic', targetId, data);
        } catch(e) {
            console.warn(hash);
            console.error(e);
        }
    }, 350);
});

Handlebars.registerHelper('getDataFromPath', function (options) {
    const data = options.hash.data;
    const keypath = options.hash.path;

    if(keypath) {
        return window.dlv(data, keypath);
    }

    return data;
});

Handlebars.registerHelper('getReactId', function (options) {
    const a = options.hash.a;
    const b = options.hash.b;

    return  b ? 'react-inject-' + a + '-' + b : 'react-inject-' + a;
});

Handlebars.registerHelper('isEnablePathScope', function (options) {
    return window.isEnablePathScope ?? false;
});

/* Funciones Inmediatas =========================================================== */

(function ($) {
    $.fn.shuffle = function () {

        var allElems = this.get(),
            getRandom = function (max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function () {
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
            });

        this.each(function (i) {
            $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);

    };

    if (!detectmob()) {
        createNiceScroll($('body'));
    }

})(jQuery);

(function ($) {

    function reposition(modalSelector) {

        var modal = modalSelector;
        var dialog = modal.find('.modal-dialog');
        modal.css('display', 'block');

        // Dividing by two centers the modal exactly, but dividing by three
        // or four works better for larger screens.
        if (dialog.css("position") != 'absolute') {
            dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
        }
    }

    function setZoomInOutOption(modalSelector) {

        const modalImage =  $('.document-modal-img').last();
        const imageNaturalWidth = modalImage[0].naturalWidth;
        const imageNaturalHeight = modalImage[0].naturalHeight;
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();

        if (imageNaturalWidth !== imageNaturalHeight && (imageNaturalWidth > windowWidth || imageNaturalHeight > windowHeight)) {

            const zoomBy = imageNaturalWidth >= imageNaturalHeight ? 'zoom-width' : 'zoom-height';
            modalImage.addClass('zoom-in');

            modalImage.addClass('zoom-out');
            modalImage.removeClass('zoom-in');
            modalImage.addClass(zoomBy);

            reposition(modalSelector);

        }

    }

    // Reposition when a modal is shown
    $(document).on("shown.bs.modal", '.modal', function() {
        const modalSelector = $(this);
        if ($('#iframe-modal.modal-IMAGE').length > 0) {
            $('#iframe-modal .document-modal-img').one('load', function () {
                reposition(modalSelector);
                setZoomInOutOption(modalSelector);
            });
        } else if ($('#iframe-modal.modal-VIDEO').length > 0) {
            $('#videoContainer video').one('loadeddata', function() {
                reposition(modalSelector)
            })
        } else {
            reposition(modalSelector);
        }

    });

    // Reposition when the window is resized
    $(window).on('resize', function () {
        $('.modal:visible').each(function() {
            reposition($(this))
        });
        loginController.loginFromStyles();
    });
})(jQuery);

(function($) {
    $.fn.hasScrollBar = function() {
        return this.get(0).scrollHeight > this.height();
    }
})(jQuery);

/* Funciones =========================================================== */

function tintImage2($img, color) {

    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

        var svg = $svg.find('path');
        var svg2 = $svg.find('rect');
        var svg3 = $svg.find('polygon');
        svg.attr('fill', '#' + color);
        svg2.attr('fill', '#' + color);
        svg3.attr('fill', '#' + color);

    }, 'xml');


}

function isJson(obj) {
    var t = typeof obj;
    return ['boolean', 'number', 'string', 'symbol', 'function'].indexOf(t) == -1;
}

function notify(message, type, allow_dismiss = true) {
    $.notify({
        message: message,
        title: "",
    }, {
        type: type,
        allow_dismiss: allow_dismiss,
        label: 'Cancel',
        className: 'btn-xs btn-inverse',
        placement: {
            from: 'top',
            align: 'center'
        },
        delay: 300000,
        animate: {
            enter: 'animated bounceIn',
            exit: 'animated bou nceOut'
        },
        offset: {
            x: 20,
            y: 125
        }
    });
}

function tintImage(canvasId, image, color) {

    var drawingCanvas = document.getElementById(canvasId);

    // Check the element is in the DOM and the browser supports canvas
    if (drawingCanvas && drawingCanvas.getContext) {


        // Initaliase a 2-dimensional drawing context
        var x = drawingCanvas.getContext('2d');
        var width = x.canvas.width;
        var height = x.canvas.height;
        var fg = new Image();

        fg.onload = function () {

            // create offscreen buffer,
            var buffer = document.createElement('canvas');
            buffer.width = fg.width;
            buffer.height = fg.height;
            var bx = buffer.getContext('2d');


            bx.fillStyle = '#' + color;
            //bx.fillStyle = '#00ff00' ;
            bx.fillRect(0, 0, buffer.width, buffer.height);

            bx.globalCompositeOperation = "destination-atop";
            bx.drawImage(fg, 0, 0);


            // to tint the image, draw it first
            x.drawImage(fg, 0, 0);

            //then set the global alpha to the amound that you want to tint it, and draw the buffer directly on top of it.
            x.globalAlpha = 1;
            x.clearRect(0, 0, drawingCanvas.width, drawingCanvas.height);
            x.drawImage(buffer, 0, 0, drawingCanvas.width, drawingCanvas.height);


            if ($(drawingCanvas).hasClass('canvasCheckAspect')){
                if (fg.width > fg.height) {
                    $(drawingCanvas).css('height', 'auto');
                    $(drawingCanvas).css('margin-top', '18px');
                }
            }


        };
        fg.src = image ? image : '';
    }
}

function sprintf() {

    var replaceRegularExpression = /%((%)|s|d|.[0-9]g)/g;
    var args = arguments;
    var string = args[0] ?? '';
    var argsIndex = 1;
    
    return (string || '').replace(replaceRegularExpression, function(matchedFormat) {

        var value = args[argsIndex];
        var decimalEspecification = matchedFormat.indexOf('.');
        var decimalsNumber = decimalEspecification >= 0 ? matchedFormat[decimalEspecification + 1] : 0;

        switch (matchedFormat) {

            // Sustituye el valor de '%s' por una cadena de texto
            case '%s':
                value = value.toString();
                break;

            // Sustituye el valor de '%d' por un decimal sin especificacion de longitud
            case '%d':
                var valueFloat = parseFloat(value);
                value = formatValueByLocale(valueFloat);
                break;

            // Sustituye el valor de '%.<decimales>g por un decimal con especificacion de longitud y ausencia de ceros finales
            case '%.' + decimalsNumber + 'g':
                var valueString = value.toString();
                var decimalPosition = valueString.indexOf('.');
                var valueSubstringEnd = decimalPosition >= 0 ? decimalPosition + parseInt(decimalsNumber) + 1 : valueString.length;
                var valueSubstring = valueString.substring(0, valueSubstringEnd)
                value = formatValueByLocale(parseFloat(valueSubstring));
                break;
        }

        argsIndex += 1;
        return value;

    });

}

function formatValueByLocale(value) {

    var roundedValue = Math.round(parseFloat(value) * 10) / 10;
    var valueSplit = Math.abs(roundedValue).toString().split('.');
    var integerPart = valueSplit[0];
    var decimalPart = valueSplit[1];
    var integerPartCounter = 0;
    var integerPartFormatted = '';
    var valueFormatted = '';
    var milesNotation = '.';
    var decimalNotation = ',';

    for(var index = integerPart.length - 1; index >= 0; index -= 1) {

        integerPartCounter += 1;

        if (integerPartCounter === 4) {
            integerPartFormatted = milesNotation + integerPartFormatted;
            integerPartCounter = 1;
        }

        integerPartFormatted = integerPart[index] + integerPartFormatted;

    }

    valueFormatted = integerPartFormatted;

    if (decimalPart) {
        valueFormatted = valueFormatted + decimalNotation + decimalPart.substr(0, 1);
    }

    return value < 0 ? '-' + valueFormatted : valueFormatted;
}

function secondsToHHMMSS(totalSec) {
    var hours = parseInt(totalSec / 3600);
    var minutes = parseInt(totalSec / 60) % 60;
    var seconds = parseInt(totalSec % 60);

    var result = (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
    return result;
}

function msToHHMMSS(ms) {
    return secondsToHHMMSS(ms / 1000);
}

function dynamicSort(property, objectName) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = (a[objectName][property] < b[objectName][property]) ? -1 : (a[objectName][property] > b[objectName][property]) ? 1 : 0;
        return result * sortOrder;
    }
}

function createProgressChart(elem, progress) {

    var size = '80%';
    if (window.screen.availWidth < 500) {
        size = '40%'
    }

    elem.highcharts({
        chart: {
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            backgroundColor: 'transparent'
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        title: {
            text: ''
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
                size: size,
                dataLabels: {
                    enabled: false
                },
                borderColor: null,
                center: ['50%', '50%'],
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }
        },
        series: [{
            type: 'pie',
            innerSize: '90%',
            data: [
                ['', progress],
                ['', 100 - progress]
            ],
            colors: [
                '#FFF', 'rgba(255,255,255,0.4)'
            ]
        }]
    });

}

function createGameSummaryChart(elem, mAnswers, bAnswers, pAnswers, nAnswers, totalAnswers) {
    var mAnswerProgress = mAnswers / totalAnswers * 100;
    var bAnswerProgress = bAnswers / totalAnswers * 100;
    var pAnswerProgress = pAnswers / totalAnswers * 100;
    var nAnswerProgress = nAnswers / totalAnswers * 100;
    var data = [];
    var colors = [];

    if(mAnswerProgress > 0) {
        data.push(['', mAnswerProgress]);
        colors.push('#6cc33c');
    }
    if(bAnswerProgress > 0) {
        data.push(['', bAnswerProgress]);
        colors.push('#ff9800');
    }
    if(pAnswerProgress > 0) {
        data.push(['', pAnswerProgress]);
        colors.push('#ff6100');
    }
    if(nAnswerProgress > 0) {
        data.push(['', nAnswerProgress]);
        colors.push('#F5222D');
    }

    elem.highcharts({
        chart: {
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            backgroundColor: 'transparent',
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        title: {
            text: ''
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false
                },
                borderColor: null,
                center: ['50%', '50%'],
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }
        },
        series: [{
            type: 'pie',
            innerSize: '90%',
            data: data,
            colors: colors
        }]
    });
}

function getNiceScrollStyle() {
    return {
        cursorcolor: "#424242",
        cursoropacitymax: .8,
        cursorwidth: "12px",
        cursorborderradius: "6px",
        cursorborder: "1px solid #ccc",
        touchbehavior: detectmob(),
        preventmultitouchscrolling: false,
        zIndex: 10,
        scrollspeed: 15,
        mousescrollstep: detectWindows() ? 30 : 10,
    }
}

function createNiceScroll(selector) {
    console.warn('createNiceScroll: This function is deprecated...');
}

function removeNiceScroll() {
    console.warn('removeNiceScroll: This function is deprecated...');
}

function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 15; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};

function loadTranslator(language) {

    try {
        $('#localeScript').remove();
        $('#localeScriptParser').remove();

        var s2 = document.createElement("script");
        s2.type = "text/javascript";
        s2.id = 'localeScriptParser';
        s2.src = "/js/bundles/bazingajstranslation/js/translator.min.js?cachebuster=" + new Date().getTime();
        $("head").append(s2);

        var s = document.createElement("script");
        s.type = "text/javascript";
        s.id = 'localeScript';
        s.src = "/js/dist/translations/translations_" + language + ".js";
        $("head").append(s);
    } catch(e) {
        console.error(e);
    }

    storage.setItem("locale", language);
}

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function detectmob() {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    }
    else {
        return false;
    }
}

function detectWindows() {
    return ["Windows", "Win16", "Win32"].indexOf(navigator.platform) >= 0;
}

function qs(key, lmsSpecial) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
    var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
    var value = match && decodeURIComponent(match[1].replace(/\+/g, " "));
    if (key == 'token' && value) {
        localStorage.setItem("lms_token", value);
    }

    if (key == 'token' && !value && lmsSpecial) {
        return localStorage.getItem("lms_token");
    }
    return value;
}

function redirectToLogin(token) {
    location.href = Routing.generate('cuatro_ochenta_front_office_token_login', {token: token});
}

function receiveMessage(event) {
    var data = event.data;

    if (data && data.source === 'scorm') {
        console.log("🚀 ~ data received from scorm. data:", data)
        if (data.msj === 'logged') {
            redirectToLogin(data.token);
        } else {
            //Comprobar que el external_id está registrado en el mundo
            $.ajax({
                type: "POST",
                url: Routing.generate('lms_check_external_id', {
                    world_token: qs('token', true),
                    external_id: data.external_id
                }),
                data: JSON.stringify({
                    name: data.name,
                    username: data.username
                }),
                success: function success(response) {
                    var jsonObject = response;

                    if (!isJson(jsonObject)) {
                        jsonObject = $.parseJSON(response);
                    }
                    if (!jsonObject.success) {

                        //iseazy LMS version
                        if(data.is_special){
                            var emailValue = data.name.substring(data.name.lastIndexOf("(")+1,data.name.lastIndexOf(")"));

                            $.get(
                                Routing.generate(
                                    'lms_check_melia_email',
                                    {email: emailValue,external_id: data.external_id,token: qs("token", true) }
                                ),
                                function( data ) {
                                    var jsonObject = data;
                                    if (!isJson(jsonObject)) {
                                        jsonObject = $.parseJSON(data);
                                    }

                                    if (jsonObject.success) {
                                        qs("register")
                                        var datamsj = {
                                            msj: 'register',
                                            result: {
                                                user: {
                                                    encrypted_user_world: jsonObject.result.encrypted_user_world
                                                }
                                            }
                                        };

                                        window.parent.postMessage(datamsj, '*');
                                        redirectToLogin(jsonObject.result.encrypted_user_world);
                                    }

                                });
                        }
                        else{
                            // TODO register error (sentry, console, etc)
                        }

                        return false;
                    }
                    else {
                        response.msj = 'register';
                        window.parent.postMessage(response, '*');
                        redirectToLogin(response.result.user.encrypted_user_world);

                        return false;
                    }
                },
                error: function(e) {
                    console.trace('fail lms_check_external_id: ', {e});
                }
            });
        }
    }

    if(data && (data.source === "previewer" || data.source === 'manager')){
        if (localStorage.getItem('world')) {
            localStorage.removeItem('world');
        }

        window.blackBox.setAvatar('ads', data.user );
        window.blackBox.setPhrase('manager', data.password, true);

        api.getWorldThemeAdminPreview(data.token);
    }

}

function addThemeStyles(theme) {
    if(!cssCreated){

        var sheet = (function () {
            var style = document.createElement("style");
            style.appendChild(document.createTextNode(""));
            document.head.appendChild(style);
            return style.sheet;
        })();

        sheet.insertRule('.world_color_1 { color: #' + theme.color_1 + ' !important; }', 0);
        sheet.insertRule('.world_color_2 { color: #' + theme.color_2 + ' !important; }', 0);
        sheet.insertRule('.world_color_3 { color: #' + theme.color_3 + ' !important; }', 0);
        sheet.insertRule('.world_color_4 { color: #' + theme.color_4 + ' !important; }', 0);
        sheet.insertRule('.world_color_5 { color: #' + theme.color_5 + ' !important; }', 0);
        sheet.insertRule('.world_color_1_bg { background-color: #' + theme.color_1 + ' !important; }', 0);
        sheet.insertRule('.world_color_2_bg { background-color: #' + theme.color_2 + ' !important; }', 0);
        sheet.insertRule('.world_color_3_bg { background-color: #' + theme.color_3 + ' !important; }', 0);
        sheet.insertRule('.world_color_4_bg { background-color: #' + theme.color_4 + ' !important; }', 0);
        sheet.insertRule('.world_color_5_bg { background-color: #' + theme.color_5 + ' !important; }', 0);
        sheet.insertRule('.world_color_1_bc { border-color: #' + theme.color_1 + ' !important; }', 0);
        sheet.insertRule('.world_color_2_bc { border-color: #' + theme.color_2 + ' !important; }', 0);
        sheet.insertRule('.world_color_3_bc { border-color: #' + theme.color_3 + ' !important; }', 0);
        sheet.insertRule('.world_color_4_bc { border-color: #' + theme.color_4 + ' !important; }', 0);
        sheet.insertRule('.world_color_5_bc { border-color: #' + theme.color_5 + ' !important; }', 0);
        sheet.insertRule('.world_text_color { color:#' + theme.login_text_color + ' !important; }', 0);
        sheet.insertRule('.world_text_color_bg { background-color:#' + theme.login_text_color + ' !important; }', 0);
        sheet.insertRule('.world_text_color_bc { border-color:#' + theme.login_text_color + ' !important; }', 0);

        sheet.insertRule('.world_base_color { color:#' + theme.base_color + ' !important; }', 0);
        sheet.insertRule('.world_base_color_bg { background-color:#' + theme.base_color + ' !important; }', 0);
        sheet.insertRule('.world_base_dark_dark_color_bg { background-color:#' + theme.base_dark_dark_color + ' !important; }', 0);
        sheet.insertRule('.world_base_dark_color_bg { background-color:#' + theme.base_dark_color + ' !important; }', 0);

        sheet.insertRule('.uil-rolling-css > div div {border-color:#' + theme.base_color + '}', 0);
        sheet.insertRule('textarea, textarea.form-control, input.form-control, input[type=text], input[type=password], input[type=email], input[type=search], input[type=number], [type=text].form-control, [type=password].form-control, [type=email].form-control, [type=search].form-control, [type=tel].form-control, [contenteditable].form-control {' +
            'color:#' + theme.login_text_color + ' }', 0);
    }

    cssCreated = true;
}

function hex2rgba(hex, alpha) {

    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    var a = (alpha > 1.0) ? alpha / 255 : alpha;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}

function validateUrl(str) {
    var regex = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

    if(!regex.exec(str))
        return false;

    return true;
}

var wrapURLs = function (text, new_window) {

    // Evitar duplicar el wrap y que el mensaje salga como texto de html
    if (text.indexOf('<a') >= 0) {
        return text;
    }

    var url_pattern = /(?:(?:https?):\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)?/ig;
    var target = (new_window === true || new_window == null) ? '_blank' : '';

    return text.replace(url_pattern, function (url) {
        var protocol_pattern = /^(?:(?:https?):\/\/)/i;
        var href = protocol_pattern.test(url) ? url : '//' + url;
        return '<a href="' + href + '" target="' + target + '" style="color: #0700E3">' + url + '</a>';
    });
};

function rgb2hex(rgb){
    if(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

        return ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2);
    }
}

/**
 * @param {Object} selector
 * @param {Array<String> | null} events
 * @return {Object<Array<Object>> | Object<boolean, Array<Object>>}
 **/
function checkSelectorEvents(selector, events) {
    if (selector.length > 0) {
        const selectorEventsData = jQuery._data(selector[0], 'events');
        const selectorEventsList = selectorEventsData ? selectorEventsData : [];
        const selectorEventsListNames = Object.keys(selectorEventsList);
        let eventsIncluded = true;

        if (!events) {
            return {selectorEventsList: selectorEventsList};
        }

        _.forEach(events, function(event) {
            if (selectorEventsListNames.indexOf(event) < 0) {
                eventsIncluded = false;
                return;
            }
        });

        return {eventsIncluded: eventsIncluded, selectorEventsList: selectorEventsList};
    }

    return {eventsIncluded: false, selectorEventsList: []};
}

function removeUserAccessStorage() {
    // console.log("🚀 ~ removeUserAccessStorage");
    localStorage.removeItem('access_token');
    localStorage.removeItem('external_login');

    if (localStorage.getItem('login_source') === 'platform') {
        localStorage.removeItem('world');
    }
    localStorage.removeItem('login_source');

    window.blackBox.logout();
}

function getPasswordCriteria() {
    return new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\'"#?!@=_$%^&*-\.:]).{8,}$');
}

function sha256(string) {
    const hash = sjcl.hash.sha256.hash(string);
    return sjcl.codec.hex.fromBits(hash);
}

function gxs(length) {
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
    }
    return result.join('');
}

function formatDateTimeATOM(date, time) {

    const dateSplit = date.split("/");
    const year = dateSplit[2];
    const month = dateSplit[1];
    const day = dateSplit[0];
    const dateFormatted = year + "-" + month + "-" + day + " " + time;

    return new moment(dateFormatted).format();

}

function parseATOMDate(date) {
    return new moment(date).format("DD/MM/YYYY");
}

function parseATOMTime(time) {
    return new moment(time).format("HH:mm");
}

function pauseMedia(media) {
    if (media && !media.paused) {
        media.pause();
    }
}

// Función para formatear las fechas de toda la aplicacion a partir de una fecha en milisegundos.
function formatToDateSystem(timestamp) {

    var date = new Date(0);
    var now = new Date().getTime(); // Milisegundos
    var dayOfEventInMiliseconds = timestamp * 1000; // Milisegundos
    var difference = now - dayOfEventInMiliseconds;

    var minute = 60000;
    var hour = 60 * minute;
    var day = 24 * hour;
    var dayOfEvent = moment(dayOfEventInMiliseconds).format("D MMM YY");
    var today = moment().format("D MMM YY");
    var tomorrow = moment().add(1, "days").format("D MMM YY");
    var yesterday = moment().add(-1, "days").format("D MMM YY");

    // Fechas pasadas
    if (dayOfEvent <= yesterday || (dayOfEvent === today && now >= dayOfEventInMiliseconds)) {

        switch (true) {

            case (dayOfEvent < yesterday):
                return "<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("D MMM YY").toLowerCase() + "</span>" + " " +"<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("HH:mm") + "</span>";

            case (dayOfEvent === yesterday):
                return "<span class='date-system-format'>" + Translator.trans("TR_AYER") + "</span>" + " " + "<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("HH:mm") + "</span>";

            case (dayOfEvent === today && (difference >= hour)):
                return "<span class='date-system-format'>" + Translator.trans("TR_HOY") + "</span>" + " " + "<span class='date-system-format'>" + sprintf(Translator.trans("TR_HACE_X_H"), Math.round(difference / hour)) + "</span>";

            case ((dayOfEvent === today && (difference < hour))):
                return "<b class='date-system-highlight'>" + Translator.trans("TR_AHORA_MISMO") + "</b>";
        }
    // Fechas futuras
    } else {

        switch(true) {

            case (dayOfEvent > tomorrow):
                return "<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("D MMM YY").toLowerCase() + "</span>" + " " +"<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("HH:mm") + "</span>";

            case (dayOfEvent === tomorrow):
                return "<span class='date-system-format'>" + Translator.trans("TR_MANANA") + "</span>" + " " + "<span class='date-system-format'>" + moment(dayOfEventInMiliseconds).format("HH:mm") + "</span>";

            case (dayOfEvent === today):
                return "<span class='date-system-format'>" + Translator.trans("TR_HOY") + "</span>" + " " + "<span class='date-system-format'>" + sprintf(Translator.trans("TR_EN_X_H"), Math.round(Math.abs(difference / hour))) + "</span>";

        }

    }

}

/* Otros =========================================================== */

jQuery.expr[':'].ContainsIgnore = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};

window.addEventListener("message", receiveMessage, false);

window.onbeforeunload = function () {
    // Clean up any existing loading backdrops before showing the loading modal
    $('.loadingBackdrop').remove();
    $('#modalLoading').modal('show');
};

$(document).ajaxStop(function () {
    $('#modalLoading').modal('hide');
    $('.loadingBackdrop').remove();
    // Clean up any orphaned modal backdrops that might be left behind
    $('.modal-backdrop').each(function() {
        if (!$(this).siblings('.modal:visible').length) {
            $(this).remove();
        }
    });

    // La limpieza anterior corre mientras #modalLoading aún se está ocultando (sigue `:visible` durante el
    // fundido) y respeta su backdrop; si un `show` solapado lo dejó huérfano, se retira al terminar la animación.
    setTimeout(function () {
        if (!$('.modal:visible').length) {
            $('.modal-backdrop').remove();
        }
    }, 600);
});

$(document).on("keyup", '.countme', function () {
    var countfield = $(this).closest('.form-group').find('.inputcounter');
    var numChars = $(this).val().length;
    var maxLength = $(this).attr('maxlength');
    countfield.val(maxLength - numChars);
});

$(window).on('resize', function () {
    // En el listado de amigs/retos/chat, adaptar el div central para que ocupe el espacio disponible
    rankingScreenController.adaptDivToContentRankingUsersList();

    // En el juego, hacer pequeña el circulo del tiempo
    if (playScreenController) {
        playScreenController.resizeCircleTime();
    }
});
